import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import type { Props as ButtonProps } from '@sorare/core/src/atoms/buttons/Button';
import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';

import { UpsertWatchlistDialog } from '#src/components/watchlists/UpsertWatchlistDialog/index.tsx';

type Props = ButtonProps & { onSuccess?: () => void };

export const AddWatchlistButton = ({ onSuccess, ...props }: Props) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button
        startIcon={<FontAwesomeIcon icon={faPlus} size="sm" />}
        onClick={() => setOpen(true)}
        {...props}
      >
        <FormattedMessage defaultMessage="New" />
      </Button>
      <UpsertWatchlistDialog
        open={open}
        onClose={() => setOpen(false)}
        onSuccess={onSuccess}
      />
    </>
  );
};
